import React, { Fragment, useEffect, useState } from 'react';
import { LogOut, Pricing } from '../../Constant';
import { Card, Col, Container, Row } from 'reactstrap';
import HeaderCard from '../../Components/Common/Component/HeaderCard';
import Standards from '../../Components/App/Ecommerce/PricingMemberShip/Standard';
import { postMasterToken } from '../../Utils/restUtils';
import { packageSubscription, postSubscription } from '../../CommonUrl';
import { useDispatch, useSelector } from 'react-redux';
import HandleHomePageError from '../../Components/Common/ErrorImport/SignError';
import { useLocation, useNavigate } from 'react-router';
import Transparentspinner from '../../Components/Common/Loader/Transparentspinner';
import NavSign from '../Sign/NavSign';
import { setCompanyId } from '../../Redux/Reducer';

const SubscriptionSection = () => {
    const location = useLocation();
    const trial = location?.state?.trial;
    const upgradeText = location.state?.text;
    const authState = useSelector((state) => state.auth);
    const id = location?.state?.id || authState?.companyId;
    const [priceDetails, setPriceDetails] = useState([]);
    const [loading, setloading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        packageApi();
        if (id) {
            dispatch(setCompanyId(id))
        }
    }, []);


    // useEffect(() => {
    //     if (location.state?.fromDashboard) {
    //         window.onpopstate = () => {
    //             navigate(`${process.env.PUBLIC_URL}/dashboard/default`, { replace: true });
    //         }
    //     } else {
    //         window.onpopstate = () => {
    //             navigate("/signin");
    //         }
    //     }
    // }, []);

    const packageApi = async () => {
        setloading(true)
        const response = await postMasterToken(packageSubscription, { industry_type_id: authState.industryId,iso_code:authState.country });
        if (response.status === 200) {
            setPriceDetails(response.data.data);
        }
        else {
            // navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            HandleHomePageError(navigate, response.status)
            setloading(false)

        }
        setloading(false)
    }

    return (
        <div>
            {loading && <Transparentspinner />}
            <NavSign showProfile={true} buttonText={LogOut} />
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#eff3f9",
                    height: "100%",
                }}
            >
                <Fragment>
                    {loading && <Transparentspinner />}
                    <Container fluid={true} style={{ marginTop: '50px', marginBottom: '35px' }}>

                        <Card>
                            <div className='d-flex justify-content-between align-items-center'>

                                <HeaderCard title={Pricing} details={priceDetails} />

                                {
                                    authState?.subStatus?.status === 'Active' &&

                                    <button className='btn btn-light me-4' onClick={() => {
                                        navigate('/dashboard/default')
                                    }}>Close</button>
                                }
                            </div>

                            {priceDetails?.packages?.length > 0 &&
                                <Standards details={priceDetails} auth={authState} trialShow={trial} companyId={id} upgradeText={upgradeText} />
                            }
                        </Card>
                    </Container>
                </Fragment>
            </div>
        </div>
    );
};

export default SubscriptionSection;
